// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"633":"6676183c","685":"305e9c65","906":"b0247cff"}[chunkId] + ".chunk.css";
};